import { DRAG_HANDLE_WIDTH, RIGHTBAR_RIDES_WIDTH } from "./common.const";

const RIDE_DRAWER_HANDLE_COUNT = 2;
const RIDE_DRAWER_DEFAULT_TOTAL_WIDTH = parseInt(RIGHTBAR_RIDES_WIDTH, 10);

export const RIDE_DRAWER_TOTAL_HANDLE_WIDTH =
  RIDE_DRAWER_HANDLE_COUNT * DRAG_HANDLE_WIDTH;
export const RIDE_DRAWER_DEFAULT_FORM_WIDTH = 720;
export const RIDE_DRAWER_DEFAULT_MAP_WIDTH =
  RIDE_DRAWER_DEFAULT_TOTAL_WIDTH -
  RIDE_DRAWER_DEFAULT_FORM_WIDTH -
  RIDE_DRAWER_TOTAL_HANDLE_WIDTH;
export const RIDE_DRAWER_MIN_FORM_WIDTH = 428;
export const RIDE_DRAWER_MIN_MAP_WIDTH = 18;
export const RIDE_DRAWER_RESIZE_KEYBOARD_STEP = 20;
export const RIDE_DRAWER_MAP_RESIZE_THROTTLE_MS = 300;
